export const GET_MARKET_FEED_WAIT = 'GET_MARKET_FEED_WAIT' //Constants related to feeds/inspiration
export const GET_MARKET_FEED = 'GET_MARKET_FEED'
export const GET_MARKET_FEED_PAGINATION = 'GET_MARKET_FEED_PAGINATION' //pagination feeds
